var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 83,
    viewBox: "0 0 88 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.44531 72.7935V31.6883C1.44531 28.6101 3.03379 25.7355 5.67838 24.028L38.9498 2.54623C42.1429 0.484591 46.3028 0.484592 49.4959 2.54623L82.7672 24.028C85.4118 25.7355 87.0003 28.6101 87.0003 31.6883V72.7935M1.44531 72.7935C1.44531 77.8781 5.70134 82 10.9514 82H77.4942C82.7443 82 87.0003 77.8781 87.0003 72.7935M1.44531 72.7935L33.5284 52.0789M87.0003 72.7935L54.9172 52.0789M1.44531 31.3644L33.5284 52.0789M87.0003 31.3644L54.9172 52.0789M54.9172 52.0789L49.4959 55.5792C46.3028 57.6409 42.1429 57.6409 38.9498 55.5792L33.5284 52.0789",
    stroke: "#330088",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.a167d62122d99d5a902f77ed53bfb3bf.svg";
export { ForwardRef as ReactComponent };